import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBehaviorCompletion = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4536 3.0625C11.8358 3.0625 12.9566 4.18332 12.9566 5.56554V11.4972C12.9566 12.8794 11.8358 14.0003 10.4536 14.0003H5.54735C4.16513 14.0003 3.04431 12.8794 3.04431 11.4972V5.56554C3.04431 4.18332 4.16513 3.0625 5.54735 3.0625M6.02738 8.89407L7.32204 10.1887L9.97164 7.53907M9.5489 4.19041H6.4511C5.95165 4.19041 5.54691 3.78566 5.54691 3.28622V2.90418C5.54691 2.40474 5.95165 2 6.4511 2H9.5489C10.0484 2 10.4531 2.40474 10.4531 2.90418V3.28622C10.4531 3.78566 10.0484 4.19041 9.5489 4.19041Z",
		stroke: "#596180",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBehaviorCompletion;
